export default "__VITE_ASSET__D_x_ZgMK__"